import React, { useState } from "react";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleEmailChange,
  handleError,
  handleNumbersChange,
  handleSuccess,
} from "../../CommonJquery/CommonJquery";
import Loader from "../../pages/Loader";
import {
  save_new_user,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
let click_time = 0;
const AddUserLayer = ({ viewId, handleClose, master_data_get }) => {
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);

  const handleSubmit = async (form_data, url) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data && click_time === 0) {
      setShowLoaderAdmin(true);
      click_time = 1;
      let fd_from = combiled_form_data(form_data, null);
      if (viewId == "Direct") {
        fd_from.append("id", 0);
      } else {
        fd_from.append("id", viewId.bus_cus_id);
      }
      await server_post_data(url, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data1 = Response.message.split("~@~");
          if (parseInt(data1[0]) === 1) {
            handleError(data1[1]);
          } else {
            empty_form(form_data);
            click_time = 0;
            handleSuccess("Saved Successfully");
            handleClose();
            window.location.reload();
          }
        })
        .catch((error) => {
          click_time = 0;
          console.log(error);
          setShowLoaderAdmin(false);
        });
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {ShowLoaderAdmin && <Loader />}
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-12 col-xl-12 col-lg-12">
            <div className="card border">
              <div className="card-body">
                <h6 className="text-lg text-primary-light mb-16">
                  Add New Customer
                </h6>
                <form id="SaveUpdateUser">
                  <div className="">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8 trio_mandatory"
                      id="name"
                      name="name"
                      minLength={3}
                      maxLength={30}
                      placeholder="Enter Full Name"
                      onInput={handleAphabetsChange}
                      defaultValue={(viewId && viewId.name_user) || ""}
                    />
                    <span className="condition_error"></span>
                  </div>
                  <div className="">
                    <label
                      htmlFor="email"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control radius-8 trio_mandatory"
                      id="email"
                      name="email"
                      minLength={3}
                      maxLength={300}
                      onInput={handleEmailChange}
                      placeholder="Enter email address"
                      defaultValue={(viewId && viewId.email) || ""}
                    />
                    <span className="condition_error"></span>
                  </div>
                  <div className="">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Phone
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8 trio_mandatory"
                      id="number"
                      name="number"
                      minLength={10}
                      maxLength={10}
                      onInput={handleNumbersChange}
                      placeholder="Enter phone number"
                      defaultValue={(viewId && viewId.contact_no) || ""}
                    />
                    <span className="condition_error"></span>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-50 py-11 radius-8"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-50 py-12 radius-8"
                      onClick={() =>
                        handleSubmit("SaveUpdateUser", save_new_user)
                      }
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserLayer;
